module.exports = __webpack_public_path__ + "3.png?7615d7da6d79973611a742d361255dfe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/patterns/3.png
// module id = 617
// module chunks = 0